import React from 'react'
import PropTypes from 'prop-types'
import { consoleLog } from '../../util'
import { Content } from './style'

const Message = ({ isLoading = false, isSuccess = false, data = null, isError = false, error = null }) => {
  if (isError) consoleLog(isLoading, isSuccess, data, isError, error)

  return (
    <>{isError && <Content>{error}</Content>}</>
  )
}

Message.propTypes = {
  isLoading: PropTypes.bool,
  isSuccess: PropTypes.bool,
  data: PropTypes.any,
  isError: PropTypes.bool,
  error: PropTypes.string
}

export default Message
